import React from "react";
import PageHero from "../components/ui-custom/PageHero";
import GlassCard from "../components/ui-custom/GlassCard";
import Reveal from "../components/ui-custom/Reveal";
import StatCounter from "../components/ui-custom/StatCounter";
import SectionHeading from "../components/ui-custom/SectionHeading";
import FootprintMap from "../components/footprint/FootprintMap";
import { footprintLocations, footprintStats } from "../data/mock";
import { MapPin } from "lucide-react";

const Footprint = () => {
  return (
    <div>
      <PageHero
        eyebrow="Global Footprint"
        title="Our Global Presence"
        subtitle="Group companies across India and Türkiye, sales offices on four continents, and customers in 120+ countries."
      />
      <section className="px-4 sm:px-6 pb-16">
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <FootprintMap />
          </Reveal>
        </div>
      </section>
      <section className="px-6 pb-20">
        <div className="max-w-6xl mx-auto">
          <Reveal>
            <GlassCard className="p-8 md:p-10">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-10">
                {footprintStats.map((s, i) => (
                  <StatCounter
                    key={s.label}
                    value={s.value}
                    prefix={s.prefix}
                    suffix={s.suffix}
                    label={s.label}
                    compact
                    glow={i % 2 === 0 ? "cyan" : "amber"}
                  />
                ))}
              </div>
              <p className="mt-8 text-xs text-muted-foreground">Group figures for FY 2025-26, from the Annual Report 2025-26.</p>
            </GlassCard>
          </Reveal>
        </div>
      </section>
      <section className="px-6 pb-28">
        <div className="max-w-6xl mx-auto">
          <SectionHeading
            eyebrow="Group Companies"
            title="One Group, Across The Value Chain"
            subtitle="Subsidiaries, joint venture and associate companies as on 31 March 2026, plus the proposed Winwin acquisition."
          />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {footprintLocations.map((loc, i) => (
              <Reveal key={loc.title} delay={i * 0.06}>
                <GlassCard className="p-7 h-full flex gap-4">
                  <MapPin size={22} className="text-qcyan mt-1 shrink-0" />
                  <div>
                    <h3 className="font-display font-semibold text-foreground text-base mb-1">{loc.title}</h3>
                    <p className="text-xs text-qamber uppercase tracking-wide mb-3">{loc.type}</p>
                    <p className="text-sm text-muted-foreground leading-relaxed">{loc.detail}</p>
                  </div>
                </GlassCard>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footprint;
